<template>
  <div class="v-application">
    <v-row no-gutters class>
      <v-col cols="12">
        <slot name="titleLayout">
          <!-- {{}} -->
        </slot>
      </v-col>
      <!-- 미리보기 팝업 -->
      <i-dxpopup
        :popupVisible="popupVisible"
        :title="popupTitle"
        @popupCloseButtonClick="popupCloseButtonClick"
        :vHtmlContent="'test'"
        :height="'650'"
        width="90vw"
        max-width="650"
      >
        <template v-slot:grid>
          <i-preview :key="componentKey" :fileList="files" :propsFileData="selectedFileData"></i-preview>
        </template>
      </i-dxpopup>

      <v-col>
        <i-card-vertical
          :headerTitle="headerTitle"
          :useBtnList="buttonUseList"
          @btnSearch="btnSearch(true)"
          @btnSave="btnSave()"
          @btnDelete="btnDelete()"
          class="pa-4"
        >
          <template v-slot:body>
            <v-layout column>
              <DxDataGrid
                id="fileDataGrid"
                class
                width="100%"
                :height="readOnly ? '510px' : '290px'"
                :ref="dxDataGridRef"
                :data-source="files"
                :column-auto-width="true"
                key-expr="id"
                :key="clntId"
                @editor-preparing="onEditorPreparing"
              >
                <DxPaging :enabled="true" :page-size="5" />
                <DxPager :visible="true" :allowed-page-sizes="[5]" />

                <DxScrolling row-rendering-mode="standard" />

                <DxColumn
                  data-field="createdAt"
                  data-type="date"
                  caption="등록일자"
                  format="yyyy.MM.dd HH:mm:ss"
                  width="145px"
                  alignment="center"
                  :allow-editing="false"
                />

                <DxColumn
                  data-field="fileNm"
                  caption="파일명"
                  data-type="string"
                  :allow-editing="false"
                  cell-template="fileTemplate"
                />
                <template #fileTemplate="{data: cellInfo}">
                  <div class="d-flex">
                    <div :title="cellInfo.value">{{ cellInfo.value }}</div>
                    <div
                      v-if="cellInfo.row.data.extension != null"
                    >.{{ cellInfo.row.data.extension }}</div>
                  </div>
                </template>

                <DxColumn
                  data-field="extension"
                  caption="확장자"
                  width="60px"
                  data-type="string"
                  alignment="center"
                  cell-template="extensionIconTemplate"
                  :allow-editing="false"
                  css-class="iconCell"
                />

                <DxColumn
                  data-field="fileSize"
                  caption="용량"
                  width="70px"
                  data-type="string"
                  alignment="right"
                  :allow-editing="false"
                />

                <!-- <DxColumn data-field="filePath" caption="경로" data-type="string" width="180px" /> -->

                <DxColumn
                  data-field="useYn"
                  width="40px"
                  data-type="boolean"
                  caption="사용"
                  edit-cell-template="checkBoxEditor"
                />
                <DxColumn
                  data-field="useYn1"
                  width="80px"
                  data-type="boolean"
                  caption="미리보기"
                  cell-template="preview"
                  :allow-editing="false"
                />
                <template #preview="{ data: cellInfo }">
                  <v-btn
                    elevation="0"
                    color="btn_sub"
                    dark
                    x-small
                    class="rounded"
                    v-if="!cellInfo.data.__created__"
                    @click="previewClick(cellInfo.data)"
                  >
                    <!-- <svg-icon icon-class="preview" style="height: 1rem;"></svg-icon> -->
                    미리보기
                  </v-btn>
                </template>

                <DxColumn
                  data-field="__created__"
                  caption="다운로드"
                  data-type="string"
                  alignment="center"
                  width="80px"
                  cell-template="downloadTemplate"
                  :allow-sorting="false"
                  :allow-editing="false"
                />

                <template #checkBoxEditor="{ data: cellInfo }">
                  <DxCheckBox
                    :value="cellInfo.value == 'Y' ? true : false"
                    :onValueChanged="value => onCheckValueChanged(value, cellInfo)"
                  />
                </template>

                <template #downloadTemplate="{ data : cellInfo }">
                  <v-btn
                    elevation="0"
                    color="btn_sub"
                    width="55"
                    dark
                    x-small
                    class="rounded"
                    v-if="cellInfo.value == null"
                    @click="fileDownload(cellInfo.data)"
                  >
                    <!-- <svg-icon icon-class="download" style="height: 1rem;"></svg-icon> -->
                    <div>다운로드</div>
                  </v-btn>
                </template>

                <template #extensionIconTemplate="{ data:cellInfo }">
                  <svg-icon
                    class="excel_icon file_icon"
                    v-if="cellInfo.value == 'xlsx' || cellInfo.value == 'xls'"
                    icon-class="excel"
                  />

                  <svg-icon
                    class="jpg_icon file_icon"
                    v-else-if="cellInfo.value == 'jpg'"
                    icon-class="jpg"
                  />

                  <svg-icon
                    class="pdf_icon file_icon"
                    v-else-if="cellInfo.value == 'pdf'"
                    icon-class="pdf"
                  />

                  <svg-icon
                    class="png_icon file_icon"
                    v-else-if="cellInfo.value == 'png'"
                    icon-class="png"
                  />

                  <svg-icon
                    class="txt_icon file_icon"
                    v-else-if="cellInfo.value == 'txt'"
                    icon-class="txt"
                  />

                  <svg-icon
                    class="ppt_icon file_icon"
                    v-else-if="cellInfo.value == 'ppt' || cellInfo.value == 'pptx'"
                    icon-class="ppt"
                  />

                  <svg-icon
                    class="zip_icon file_icon"
                    v-else-if="cellInfo.value == 'zip' || cellInfo.value == 'cab'"
                    icon-class="zip"
                  />

                  <svg-icon
                    class="doc_icon file_icon"
                    v-else-if="cellInfo.value == 'doc' || cellInfo.value == 'docx'"
                    icon-class="doc"
                  />

                  <svg-icon
                    class="hwp_icon file_icon"
                    v-else-if="cellInfo.value == 'hwp' || cellInfo.value == 'hwpx'"
                    icon-class="hwp"
                  />

                  <svg-icon class="file_default_icon file_icon" v-else icon-class="file_default" />
                </template>
              </DxDataGrid>
              <div class="widget-container">
                <DxFileUploader
                  :ref="dxFileUploader"
                  :accept="fileExtension"
                  :multiple="true"
                  upload-mode="useButtons"
                  selectButtonText="Select File"
                  :show-file-list="false"
                  labelText
                  width="100%"
                  dialog-trigger="[role=btnUpload]"
                  drop-zone="#dropzone-external"
                  @uploaded="onUploaded"
                  @upload-error="onUploadError"
                  @value-changed="onValueChanged"
                  :visible="false"
                />
              </div>

              <!-- 드래그 존  -->
              <div v-if="!readOnly" id="dropzone-external">
                <div>여기에 파일 놓기</div>
              </div>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { deleteFiles, downloadFile, getFile, multiFileUpload } from '@/api/baseManage/fileUpload'
import { AesDecrypt } from '@/utils/aes256'
import { getCurrentDate } from '@/utils/common.js'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import DxCheckBox from 'devextreme-vue/check-box'
import { DxFileUploader } from 'devextreme-vue/file-uploader'
import notify from 'devextreme/ui/notify'
import { getGrpAuthCd } from '@/utils/token'

import iDxPopup from '@/components/common/iDxPopup.vue'
import IPreview from '@/components/common/iPreview.vue'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  name: 'i-file-upload',
  components: {
    DxFileUploader,
    DxCheckBox,
    'i-dxpopup': iDxPopup,
    IPreview
  },
  props: {
    headerTitle: {
      type: String,
      default: () => ''
    },
    targetId: {
      type: String,
      default: () => ''
    },
    targetType: {
      type: String,
      default: () => ''
    },
    customButtonUseList: {
      type: Array
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    fileExtension: {
      type: String,
      default: () => '*'
    }
  },
  computed: {
    fileUploader: function() {
      return this.$refs[this.dxFileUploader].instance
    }
  },
  beforeMount() {
    if (!(this.customButtonUseList === undefined || this.customButtonUseList === null)) {
      this.buttonUseList = this.customButtonUseList
    }
    if (this.readOnly) {
      this.buttonUseList = this.buttonUseList.filter(element => element.includes('btnSearch'))
    }
  },
  mounted() {
    this.btnSearch(true)
  },
  data() {
    return {
      dxDataGridRef: 'fileDataGrid',
      dxFileUploader: 'uploaderContainer',
      buttonUseList: [
        'btnSearch', //조회
        'btnUpload', //업로드
        'btnSave', //저장
        'btnDelete' //삭제
      ],
      files: [],

      maxFileSize: 1073741824,

      componentKey: 0,
      popupVisible: false,
      popupTitle: '미리보기',
      selectedFileData: 0,
      clntId: ''
    }
  },
  methods: {
    // 팝업의 변경된 props들을 반영하기 위해 사용
    forceRerender() {
      this.componentKey += 1
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    btnSearch(noti) {
      this.openLoading()
      const grpAuthCd = getGrpAuthCd()
      if (grpAuthCd === 'master'||grpAuthCd === 'kiest_admin') this.clntId = this.getClntId()
      if (!this.clntId) {
        this.clntId = this.getClntId()
      }
      let searchParams = {
        targetId: this.targetId,
        targetType: this.targetType,
        clntId: this.clntId
      }
      this.gridInit(this.GetDataGrid(this.dxDataGridRef))
      getFile(searchParams, noti)
        .then(res => {
          if (res.success) {
            this.files = []
            this.files = res.list
            console.log(this.files)
          }
        })
        .finally(() => this.endLoading())
    },
    // 저장
    async btnSave() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      console.log(selectedRows)
      if (selectedRows.length == 0) {
        this.vToastify(this.$t('selectionData'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('파일을 저장하시겠습니까?'),
        'info',
        async current => {
          this.fileSave(selectedRows)
        },
        null,
        true
      )
    },
    // 삭제
    async btnDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'warn')
        return
      }

      this.fileRemove(selectedRows)
    },
    ///////////////////////////////////////
    /*               File   Event        */
    ///////////////////////////////////////
    fileSave(selectedRows) {
      return new Promise((resolve, reject) => {
        this.openLoading()
        this.GetDataGrid(this.dxDataGridRef).saveEditData()
        let formData = new FormData()
        let i = 0
        selectedRows.forEach(element => {
          formData.append('fileList[' + i + '].fileData', element.file ? element.file : new Blob([], { type: 'application/octet-stream' }))
          formData.append('fileList[' + i + '].fileVO.targetId', this.targetId)
          formData.append('fileList[' + i + '].fileVO.targetType', this.targetType)
          formData.append('fileList[' + i + '].fileVO.useYn', element.useYn)
          formData.append('fileList[' + i + '].fileVO.clntId', this.clntId)
          i++
        })
        multiFileUpload(formData, true)
          .then(res => {
            if (res.success) {
              this.btnSearch(false)
            }
          })
          .finally(() => {
            this.endLoading()
            resolve(true)
          })
      })
    },
    fileRemove(files) {
      this.vToastifyPrompt(
        this.$t('파일을 삭제하시겠습니까?'),
        'info',
        current => {
          this.openLoading('deleting')
          deleteFiles(files, true)
            .then(res => {
              if (res.success) {
                this.btnSearch(false)
              }
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    fileDownload(rowData) {
      this.openLoading()
      // api 에 responseType: "blob" 필수, 백단에 byteArray(Blob)형태로 보내고 있기 때문
      let params = {
        clntId: rowData.clntId,
        writeDt: rowData.writeDt,
        docNo: rowData.docNo
      }

      downloadFile(params)
        .then(res => {
          let link = document.createElement('a')
          // 객체를 만들어서 생성
          let objectUrl = window.URL.createObjectURL(res)
          link.href = objectUrl
          link.download = `${rowData.fileNm}.${rowData.extension}`
          link.click()
        })
        .finally(() => this.endLoading())
    },
    onUploaded(e) {
      e.component._files.forEach((element, index) => {
        if (element._isLoaded) {
          this.fileUploader.removeFile(index)
        }
      })
      notify(this.$t('파일이 업로드 되었습니다.'), 'success', 300)
    },
    onUploadError(e) {
      e.component._files.forEach((element, index) => {
        if (element._isError) {
          this.fileUploader.removeFile(index)
          notify(this.$t('파일을 업로드 할 수 없습니다.'), 'error', 300)
        }
      })
    },
    onValueChanged(e) {
      // reset 이벤트는 재귀적으로 이 이벤트를 부르기 때문에 0일때 return 시킴
      if (e.value == null || e.value.length == 0) return

      this.openLoading()
      for (const element of e.value) {
        if (element.size >= this.maxFileSize) {
          notify(this.$t('파일이 용량이 1GB를 초과했습니다.'), 'error', 300)
          continue
        }
        let subFileName = this.getExtension(element.name)
        if (subFileName[0].length > 200) {
          notify(this.$t('파일의 이름이 200자 이상입니다.'), 'error', 300)
          continue
        }
        // if (!this.allowedFileExtensions.includes('.' + subFileName[1])) {
        //   notify(this.$t('업로드할 수 없는 확장자입니다.'), 'error', 300)
        //   continue
        // }
        let writeDt = getCurrentDate()
          .split('-')
          .join('')
        let newRow = {
          id: this.files.length + 1,
          clntId: this.clntId,
          writeDt: writeDt,
          doc_no: (this.files.length + 1).toString().padStart(5, '0'),
          file: new File([element], `${subFileName[0]}.${subFileName[1]}`),
          fileNm: subFileName[0],
          extension: subFileName[1],
          fileSize: this.getfileSize(element.size),
          useYn: 'Y',
          targetId: this.targetId,
          targetType: this.targetType
        }

        Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })

        this.files.unshift(newRow)
        this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
      }
      this.GetDataGrid(this.dxDataGridRef).updateDimensions()
      this.fileUploader.reset()
      this.endLoading()
    },
    popupCloseButtonClick() {
      this.selectedFileData = null
      this.popupVisible = false
    },
    getfileSize(size) {
      return (size / 1048576).toFixed(3) + 'MB'
    },
    getExtension(fileName) {
      let fileLen = fileName.length

      let lastDot = fileName.lastIndexOf('.')
      let extension = fileName.substring(lastDot + 1, fileLen).toLowerCase()
      let baseName = fileName.substring(0, lastDot)
      return [baseName, extension]
    },
    previewClick(data) {
      this.selectedFileData = data
      console.log(this.selectedFileData)
      this.forceRerender()
      this.popupVisible = true
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    onCheckValueChanged(value, cellInfo) {
      console.log('cellInfo', cellInfo)
      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      cellInfo.component.selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
    }
  }
}
</script>
<style lang="scss" scoped>
// .v-btn {
//   background: #ffffff !important;
//   border: 1px solid #9e9e9e;
// }

// .v-btn.v-size--default {
//   font-size: 13px;
//   height: 30px;
//   font-weight: 700;
//   line-height: 1.2;
// }

// .v-icon.v-icon {
//   font-size: 16px;
//   line-height: 1.3;
// }

.dx-master-detail-row .dx-row-focused .file_icon {
  color: #fff !important;
}
#dropzone-external {
  height: 180px;
  background-color: #e1e7f2;
  border-width: 1px;
  border-style: dashed;
  padding: 10px;
  opacity: 0.4;
  align-items: center;
}
#dropzone-external div {
  font-size: 16px;
  color: #6e6d6d;
  height: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
}
</style>
